/**
 * @packageDocumentation
 * @module HackerAPI.Pipeline.Field
 */
import { __extends } from "tslib";
import HackerAPIFetch from "../../hackerapi-fetch/hackerapi-fetch";
import { parseDate } from "../../utils/utils";
import Base from "../../base/base";
/**
 * A data container for data related to a pipeline field with static methods for interfacing with hackerapi
 * @class
 * @extends { HackerAPI.Base }
 */
var Field = /** @class */ (function (_super) {
    __extends(Field, _super);
    /**
     * Creates a field instance
     * @param field
     */
    function Field(_a) {
        var id = _a.id, name = _a.name, field_type = _a.field_type, fieldType = _a.fieldType, valid_values = _a.valid_values, validValues = _a.validValues, is_required = _a.is_required, isRequired = _a.isRequired, permissions = _a.permissions, slug = _a.slug, created_at = _a.created_at, createdAt = _a.createdAt, updated_at = _a.updated_at, updatedAt = _a.updatedAt;
        var _this = _super.call(this, {
            slug: function (k, v, m) {
                return m !== "PUT" ? [k, v] : Base.doNotSendHandler(k, v);
            }
        }) || this;
        /**
         * The ID of the field
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of the field
         * @type { string }
         */
        _this.name = name;
        /**
         * The response type expected back
         * @type { string }
         */
        _this.fieldType = field_type || fieldType;
        /**
         * The list of valid values that this field can take on. Null for all.
         * @type { any[] }
         */
        _this.validValues = valid_values || validValues;
        /**
         * If a response to this field is required
         * @type { boolean }
         */
        _this.isRequired = is_required || isRequired;
        /**
         * Permissions attached to this field
         * @type { object }
         */
        _this.permissions = permissions || {};
        /**
         * The slug of this field. Note that hackerapi.js does not support changing a field after it is initially
         * set.
         * @type { string }
         */
        _this.slug = slug;
        /**
         * When this field was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When this field was last created
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Fetches all the fields for a pipeline
     * @param pipeline
     * @param pipeline.id
     * @param token
     * @returns
     */
    Field.fetchAll = function (_a, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + id + "/fields",
            method: "GET",
            token: token
        }).then(function (data) { return data.map(function (datum) { return new Field(datum); }); });
    };
    /**
     * Fetches a field for a pipeline
     * @param pipeline
     * @param pipeline.id
     * @param field
     * @param field.id
     * @param token
     * @returns
     */
    Field.fetch = function (_a, _b, token) {
        var pipelineId = _a.id;
        var fieldId = _b.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/fields/" + fieldId,
            method: "GET",
            token: token
        }).then(function (data) { return new Field(data); });
    };
    /**
     * Creates a field for a pipeline
     * @param pipeline
     * @param pipeline.id
     * @param field
     * @param token
     * @returns
     */
    Field.create = function (_a, field, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + id + "/fields",
            method: "POST",
            token: token,
            body: field.toHackerAPIFormat()
        }).then(function (data) { return new Field(data); });
    };
    /**
     * Updates a field for a pipeline
     * @param pipeline
     * @param pipeline.id
     * @param field
     * @param user
     * @param token
     * @returns
     */
    Field.update = function (_a, field, token) {
        var id = _a.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + id + "/fields/" + field.id,
            method: "PUT",
            token: token,
            body: field.toHackerAPIFormat("PUT")
        }).then(function (data) { return new Field(data); });
    };
    /**
     * Deletes a field for a pipeline
     * @param pipeline
     * @param pipeline.id
     * @param field
     * @param token
     * @returns
     */
    Field.delete = function (_a, _b, token) {
        var pipelineId = _a.id;
        var fieldId = _b.id;
        return HackerAPIFetch({
            path: "/v2/pipelines/" + pipelineId + "/fields/" + fieldId,
            method: "DELETE",
            token: token
        });
    };
    return Field;
}(Base));
export default Field;
//# sourceMappingURL=field.js.map